import { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2, Info, Sparkles } from "lucide-react";
import api from "../../lib/api";
import { Modal, inp, lbl } from "./GearBits";

const ICONS = {
  critical: <AlertTriangle className="w-4 h-4 text-red-600 shrink-0 mt-0.5" />,
  warn: <AlertTriangle className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" />,
  info: <Info className="w-4 h-4 text-blue-500 shrink-0 mt-0.5" />,
};

/* mode=depart: "Did you forget anything?" — mode=return: "Check before you leave". */
export default function AICheckModal({ mode, trips, onClose }) {
  const [tripId, setTripId] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (tid) => {
    setBusy(true); setResult(null);
    try {
      const { data } = await api.post("/gear/ai/check", { mode, trip_id: tid || null });
      setResult(data);
    } catch { setResult({ flags: [], ai_note: null, error: true }); }
    finally { setBusy(false); }
  };
  useEffect(() => { run(""); }, [mode]); // eslint-disable-line react-hooks/exhaustive-deps

  const title = mode === "return" ? "Check before you leave" : "Did you forget anything?";
  return (
    <Modal title={title} onClose={onClose}>
      <div className="space-y-4" data-testid={`ai-check-${mode}`}>
        <div><label className={lbl}>Check against trip (optional)</label>
          <select value={tripId} onChange={(e) => { setTripId(e.target.value); run(e.target.value); }} data-testid="aicheck-trip" className={inp}>
            <option value="">All my inventory</option>
            {trips.map((t) => <option key={t.id} value={t.id}>{t.title}</option>)}
          </select></div>

        {busy && <p className="text-sm text-muted-foreground animate-pulse">Inspecting your inventory…</p>}

        {result && !busy && (
          <>
            {result.flags?.length === 0 ? (
              <div className="flex items-center gap-2 text-emerald-700 bg-emerald-50 border border-emerald-200 p-3 text-sm" data-testid="aicheck-allclear">
                <CheckCircle2 className="w-5 h-5" /> All clear — everything is accounted for!
              </div>
            ) : (
              <ul className="max-h-56 overflow-y-auto border border-zinc-200 divide-y divide-zinc-100" data-testid="aicheck-flags">
                {result.flags.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 p-2.5 text-sm">{ICONS[f.level]}<span>{f.text}</span></li>
                ))}
              </ul>
            )}
            {result.ai_note && (
              <div className="border border-violet-200 bg-violet-50 p-3 text-sm" data-testid="aicheck-ai-note">
                <div className="flex items-center gap-1.5 text-violet-700 font-bold text-xs uppercase tracking-widest mb-1">
                  <Sparkles className="w-3.5 h-3.5" /> TravelerPulse AI
                </div>
                {result.ai_note}
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
}
